import { render, staticRenderFns } from "./NewPoSidebar.vue?vue&type=template&id=4966420b"
import script from "./NewPoSidebar.vue?vue&type=script&lang=js"
export * from "./NewPoSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports